import { Button } from "react-scroll";
import { Link } from "react-scroll";

export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="main">
        <video src="./img/WCAD.mov" autoPlay loop muted playsInline />
        <div className="hero--section--content--box">
          <div className="hero--section--content">
            <h1 className="hero--section--title">WEST COAST AUTO DETAILING</h1>
            <div className="hero--section-description">
              PROTECT YOUR INVESTMENTS
              <br />
              <br />
              <Link
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                to="Contact"
                className="btn btn-outline-primary"
              >
                CONTACT
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
